import React, { useState } from 'react';
import { DERSLER, kazanimSozleri } from '../../lib/dersler.js';
import { MUFREDATLAR, ZORLUKLAR } from './sabitler';
import { KOVA_RENK, gunStr } from './yardimcilar';
import KazanimSecici from './KazanimSecici';
import PuanSecici from '../ui/PuanSecici';
import { ARAMA_PUAN_SECENEKLERI } from '../../lib/zorlukSeviye';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

// sabitKazanimOnek (slot-ders 2026-09-03): manifest slotu kazanım önekiyle
// sınırlıysa (Coğrafya-1 = COG.11) arama o önekle yapılır — önek dışı soru
// backend'de "ders uyuşmazlığı (önek)" ile 400 döner, burada hiç listelenmez.
function SoruEkleci({ apiUrl, onEkle, onTopluEkle, mevcutIds, mevcutPublicNolar, sabitDers, sabitMufredat, sabitKazanimOnek }) {
  // Manifest slotu doldururken ders KİLİTLİ: yanlış derse soru eklemek
  // backend'de "ders uyuşmazlığı" ile 400 döner, kullanıcı nedenini bilemez.
  const [aramaDers, setAramaDers] = useState(sabitDers || '');
  const [aramaMufredat, setAramaMufredat] = useState(sabitMufredat || '');
  const [aramaKonu, setAramaKonu] = useState('');
  const [aramaPublicNo, setAramaPublicNo] = useState('');
  const [aramaKazanim, setAramaKazanim] = useState('');
  const [aramaZorluk, setAramaZorluk] = useState([]);
  // Öğretmen puanı (zorluk_puan) seviyeleri — öğretmen isteği 2026-08-20: "ekleme kriteri için puan
  // ve ders filtrelemesi eklenebilsin"; 2026-10-26: her seviye checkbox (çoklu, `puan=yok,2-4,…`).
  const [aramaPuan, setAramaPuan] = useState([]);
  // Tarih araligi + bagam grubu (2026-09-21, ogretmen: "basim sayfasinda tarih
  // filtresi olsun, soru gruplarini bulamiyorum"). Tarih = uretim gunu
  // (olusturulma_zamani); grup = kaynak_detay.baglam_grubu — sonuc satirindaki
  // 🔗 rozete tiklayinca o grubun tum uyeleri listelenir.
  const [tarihMin, setTarihMin] = useState('');
  const [tarihMax, setTarihMax] = useState('');
  const [grupSuz, setGrupSuz] = useState('');
  const [sonuclar, setSonuclar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [toplam, setToplam] = useState(0);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const aramaParams = (ek = {}) => {
    const p = new URLSearchParams({ durum: 'onaylandi', limit: 30 });
    if (aramaDers) p.set('ders', aramaDers);
    if (aramaMufredat) p.set('mufredat', aramaMufredat);
    if (aramaKonu) p.set('q', aramaKonu);
    if (aramaPublicNo) {
      const n = aramaPublicNo.replace(/^#/, '');
      p.set('public_no_min', n);
      p.set('public_no_max', n);
    }
    const kazanimSuzgeci = aramaKazanim || sabitKazanimOnek || '';
    if (kazanimSuzgeci) p.set('kazanim_kodu', kazanimSuzgeci);
    if (aramaZorluk.length > 0) p.set('zorluk', aramaZorluk.join(','));
    if (aramaPuan.length > 0) p.set('puan', aramaPuan.join(','));
    if (tarihMin) p.set('tarih_min', tarihMin);
    if (tarihMax) p.set('tarih_max', tarihMax);
    if (grupSuz) p.set('baglam_grubu', grupSuz);
    Object.entries(ek).forEach(([k, v]) => (v ? p.set(k, v) : p.delete(k)));
    return p;
  };

  const ara = async (yeniArama = true, ek = {}) => {
    setYukleniyor(true);
    const off = yeniArama ? 0 : offset;
    const p = aramaParams(ek);
    p.set('offset', off);
    try {
      const token = localStorage.getItem('yks_token');
      const r = await fetch(`${apiUrl}/api/sorular/arama?${p}`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {},
      });
      const data = await r.json();
      const liste = data.sorular || [];
      setSonuclar(yeniArama ? liste : [...sonuclar, ...liste]);
      setToplam(data.toplam || 0);
      setOffset(off + liste.length);
      setHasMore(!!data.has_more);
    } catch (_) {
      setSonuclar([]);
      setToplam(0);
      setHasMore(false);
    }
    setYukleniyor(false);
  };

  const tamSoruEkle = async (id) => {
    const token = localStorage.getItem('yks_token');
    const r = await fetch(`${apiUrl}/api/sorular/batch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
      body: JSON.stringify({ ids: [id] }),
    });
    const data = await r.json();
    if (data.sorular?.[0]) onEkle(data.sorular[0]);
  };

  const tumunuEkle = async (limit = null) => {
    const idler = sonuclar.filter(s => !mevcutIds.includes(s.id)).map(s => s.id);
    const eklenecek = limit ? idler.slice(0, limit) : idler;
    if (eklenecek.length === 0) return;
    const token = localStorage.getItem('yks_token');
    const r = await fetch(`${apiUrl}/api/sorular/batch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) },
      body: JSON.stringify({ ids: eklenecek }),
    });
    const data = await r.json();
    if (data.sorular?.length) onTopluEkle(data.sorular);
  };

  const zorlukToggle = (z) => {
    setAramaZorluk(prev => prev.includes(z) ? prev.filter(x => x !== z) : [...prev, z]);
  };

  const eklenebilirCount = sonuclar.filter(
    s => !mevcutIds.includes(s.id) && !(mevcutPublicNolar || []).includes(s.public_no)
  ).length;

  return (
    <div className="mt-3 pt-3 border-t-2 border-dashed border-gray-200">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-2">
        <select value={aramaDers} disabled={!!sabitDers}
          onChange={e => { setAramaDers(e.target.value); setAramaKazanim(''); }}
          title={sabitDers ? 'Bu slot bu derse ait — ders değiştirilemez' : 'Ders'}
          className={`px-2 py-1.5 rounded-lg border text-xs ${sabitDers
            ? 'border-blue-300 bg-blue-50 font-semibold text-blue-900' : 'border-gray-300'}`}>
          {DERSLER.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
        </select>
        <select value={aramaMufredat}
          onChange={e => { setAramaMufredat(e.target.value); setAramaKazanim(''); }}
          className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs" title="Müfredat">
          {MUFREDATLAR.map(m => (
            <option key={m.v || 'hepsi'} value={m.v}>{m.v ? `Müfredat: ${m.l}` : 'Müfredat: Hepsi'}</option>
          ))}
        </select>
        <input type="text" value={aramaKonu} onChange={e => setAramaKonu(e.target.value)}
          placeholder="Konu" className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs" />
        <input type="text" value={aramaPublicNo} onChange={e => setAramaPublicNo(e.target.value)}
          placeholder="#54" className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs" />
      </div>
      <div className="mb-2">
        {sabitKazanimOnek && (
          <div className="text-[10px] text-blue-800 bg-blue-50 border border-blue-100 rounded px-2 py-1 mb-1" data-sabit-onek={sabitKazanimOnek}>
            Bu slot yalnız <b>{sabitKazanimOnek}</b> {kazanimSozleri(aramaMufredat).adlarini} alır; arama bu önekle sınırlıdır.
          </div>
        )}
        <KazanimSecici apiUrl={apiUrl} ders={aramaDers} mufredat={aramaMufredat}
          value={aramaKazanim} onChange={setAramaKazanim} />
      </div>
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <PuanSecici deger={aramaPuan} onDegis={setAramaPuan} secenekler={ARAMA_PUAN_SECENEKLERI}
          ariaLabel="Soru ekle puan seviyesi" title="Öğretmen puanı (zorluk_puan) — birden çok seviye seçilebilir; 1 puanlılar zaten basıma girmez"
          dugmeSinifi={(aktif) => `text-[10px] px-2 py-0.5 rounded font-semibold ${aktif ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`} />
      </div>
      <div className="flex flex-wrap items-center gap-1.5 mb-2">
        <span className="text-[10px] font-bold text-gray-500">Üretim tarihi:</span>
        <input type="date" value={tarihMin} max={tarihMax || undefined}
          onChange={e => setTarihMin(e.target.value)} title="Bu tarihten itibaren üretilenler"
          className="px-1.5 py-0.5 rounded border border-gray-300 text-[11px]" />
        <span className="text-[10px] text-gray-400">→</span>
        <input type="date" value={tarihMax} min={tarihMin || undefined}
          onChange={e => setTarihMax(e.target.value)} title="Bu tarihe kadar (gün dâhil)"
          className="px-1.5 py-0.5 rounded border border-gray-300 text-[11px]" />
        {[
          { l: 'Bugün', n: 0 },
          { l: '7 gün', n: 6 },
          { l: '30 gün', n: 29 },
        ].map(h => (
          <button key={h.l} onClick={() => { setTarihMin(gunStr(h.n)); setTarihMax(gunStr(0)); }}
            className="text-[10px] px-2 py-0.5 rounded font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200">
            {h.l}
          </button>
        ))}
        {(tarihMin || tarihMax) && (
          <button onClick={() => { setTarihMin(''); setTarihMax(''); }}
            className="text-[10px] px-2 py-0.5 rounded font-semibold bg-gray-100 text-gray-500 hover:bg-gray-200">
            ✕ tarih
          </button>
        )}
      </div>
      {grupSuz && (
        <div className="flex items-center gap-2 mb-2 text-[10px] text-purple-800 bg-purple-50 border border-purple-100 rounded px-2 py-1">
          <span>🔗 Bağlam grubu: <b>{grupSuz}</b></span>
          <button onClick={() => { setGrupSuz(''); ara(true, { baglam_grubu: '' }); }}
            className="px-1.5 py-0.5 rounded bg-white text-purple-700 font-semibold hover:bg-purple-100">
            ✕ gruptan çık
          </button>
        </div>
      )}
      <div className="flex items-center gap-2 mb-2">
        <span className="text-[10px] font-bold text-gray-500">Zorluk:</span>
        {ZORLUKLAR.map(z => {
          const aktif = aramaZorluk.includes(z);
          return (
            <button key={z} onClick={() => zorlukToggle(z)}
              className={`text-[10px] px-2 py-0.5 rounded font-semibold transition-colors ${aktif ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}>
              {z}
            </button>
          );
        })}
      </div>
      <button onClick={() => ara(true)} disabled={yukleniyor}
        className="w-full py-1.5 rounded-lg bg-blue-100 text-blue-700 text-xs font-semibold hover:bg-blue-200 disabled:opacity-50">
        {yukleniyor ? 'Aranıyor...' : '🔍 Ara'}
      </button>
      {sonuclar.length > 0 && (
        <>
          <div className="flex items-center justify-between mt-2 mb-1">
            <div className="text-[11px] text-gray-600">
              <strong>{sonuclar.length}</strong> / {toplam} sonuç ({eklenebilirCount} eklenebilir)
            </div>
            {eklenebilirCount > 0 && !sabitDers && (
              <div className="flex gap-1">
                <button onClick={() => tumunuEkle(10)}
                  className="text-[10px] px-2 py-0.5 rounded bg-green-50 text-green-700 hover:bg-green-100 font-semibold">
                  + İlk 10
                </button>
                <button onClick={() => tumunuEkle()}
                  className="text-[10px] px-2 py-0.5 rounded bg-green-100 text-green-800 hover:bg-green-200 font-semibold">
                  + Tümü ({eklenebilirCount})
                </button>
              </div>
            )}
          </div>
          <div className="max-h-48 overflow-y-auto space-y-1 border border-gray-100 rounded-lg p-1">
            {sonuclar.map(s => {
              // Manifest modunda kimlik anahtarı public_no (slot listesi id
              // tutmaz); seçili-soru modunda id. İkisi de kontrol edilir.
              const eklendi = mevcutIds.includes(s.id)
                || (mevcutPublicNolar || []).includes(s.public_no);
              return (
                <div key={s.id} className="flex items-center gap-2 p-1.5 rounded hover:bg-gray-50">
                  {s.public_no != null && <span className="text-[10px] bg-gray-700 text-white px-1.5 py-0.5 rounded font-mono">#{s.public_no}</span>}
                  {s.zorluk_puan != null && (
                    <span className={`text-[9px] px-1 rounded font-bold ${
                      s.zorluk_puan <= 4 ? KOVA_RENK.kolay : s.zorluk_puan >= 7 ? KOVA_RENK.zor : KOVA_RENK.orta}`}
                      title={`öğretmen puanı ${s.zorluk_puan}`}>{s.zorluk_puan}</span>
                  )}
                  {s.baglam_grubu && (
                    <button onClick={() => { setGrupSuz(s.baglam_grubu); ara(true, { baglam_grubu: s.baglam_grubu }); }}
                      title={`Bağlam grubu ${s.baglam_grubu} — tıkla, grubun tüm soruları listelensin`}
                      className="text-[9px] px-1 rounded font-bold bg-purple-100 text-purple-700 hover:bg-purple-200">
                      🔗{s.grup_sira && s.grup_toplam ? ` ${s.grup_sira}/${s.grup_toplam}` : ''}
                    </button>
                  )}
                  <span className="flex-1 text-xs text-gray-700 truncate">{s.konu} · {s.zorluk}</span>
                  {s.olusturulma_zamani && (
                    <span className="text-[9px] text-gray-400" title="üretim tarihi">
                      {String(s.olusturulma_zamani).slice(8, 10)}.{String(s.olusturulma_zamani).slice(5, 7)}
                    </span>
                  )}
                  {s.kazanim_kodu && <span className="text-[9px] text-gray-400">{s.kazanim_kodu}</span>}
                  <button onClick={() => (sabitDers ? onEkle(s) : tamSoruEkle(s.id))} disabled={eklendi}
                    title={eklendi ? 'Bu soru zaten listede' : 'Ekle'}
                    className={`text-[10px] px-2 py-0.5 rounded font-semibold ${eklendi ? 'bg-gray-200 text-gray-400' : 'bg-green-50 text-green-700 hover:bg-green-100'}`}>
                    {eklendi ? '✓' : '+ Ekle'}
                  </button>
                </div>
              );
            })}
          </div>
          {hasMore && (
            <button onClick={() => ara(false)} disabled={yukleniyor}
              className="w-full mt-1 py-1.5 rounded text-[11px] bg-gray-50 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
              {yukleniyor ? 'Yükleniyor...' : `↓ Daha yükle (${toplam - sonuclar.length} kaldı)`}
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default SoruEkleci;
